import ColorPicker from './color-picker-container'
export default ColorPicker
